export const pages = {
	'boltSplashHub': { id: 'boltSplashHub', page: 'splashHub', getter: () => import(/* webpackChunkName: 'splashHub' */ 'components/bolt/splashHub/splashHub') },
	'boltFeaturedVideos': { id: 'boltFeaturedVideos', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltFeaturedVideos', getter: () => import(/* webpackChunkName: "featuredVideos" */ 'components/bolt/featuredVideos/featuredVideos'), component: 'featuredVideos', parent: 'boltFeaturedVideos' }
];
